import { DirectionalHint } from '@fluentui/react';
import { defaultUserGovernanceConfig } from '@bingads-webui-campaign-react/multi-step-teaching-bubble';

export const TeachingBubbleConfigs = {
  featureName: 'insertion-order-report',
  userGovernanceConfig: defaultUserGovernanceConfig,
  steps: [
    {
      title: _TL_('Welcome to your insertion order (IO) report'),
      content: _TL_('The IO report allows you to track and document any daily or monthly changes to remaining budgets over a specified timeframe.'),
      primaryButtonText: _TL_('Next'),
      secondaryButtonText: _TL_(''),
      targetElement: '#ReportName.name',
      directionalHint: DirectionalHint.rightCenter,
    },
    {
      title: _TL_('Useful information about your IO budget'),
      content: _TL_('A change type is an event or action that will modify your remaining insertion order (IO) budget. There are three change types: Spend, System adjustment, and Budget change.'),
      primaryButtonText: _TL_('Next'),
      secondaryButtonText: _TL_(''),
      targetElement: '.ms-DetailsHeader-cell[data-item-key="ChangeType"] .grid-header-text',
      directionalHint: DirectionalHint.leftCenter,
    },
    {
      title: _TL_('Experiment with different views '),
      content: _TL_('Switch between daily or monthly report views.'),
      primaryButtonText: _TL_('Got it'),
      secondaryButtonText: _TL_(''),
      targetElement: '#view-selector-toolbar-item',
      directionalHint: DirectionalHint.leftCenter,
    },
  ],
};
